
const UNIT = [
    ' mmHg',
    ' beats/min',
    ' kg',
    ' lb',
    'º F',
    'º C',
    ' mg/dL',
    ' mmol/L',
    ' hours',
    ''
]
const STRESS = ['None At All', 'Normal', 'Moderately High', 'Unbearable']
const MOOD = ['Awful', 'Bad', 'Ok', 'Good', 'Great']

module.exports = function(value, unit, hideUnit) {
    // Blood pressure
    if (unit == 0) {
        let systolic = (value >> 16) & 0xffff;
        let diastolic = value & 0xffff;
        value = parseInt(systolic) + ' / ' + parseInt(diastolic)
    }
    else if (unit == 9) {
        return '<strong>' + MOOD[value] + '</strong>'
    }
    else if (unit == null) {
        return '<strong>' + STRESS[value] + '</strong>'
    }
    else if (typeof value === 'number')
        value = '' + value.toFixed(1)

    return '<strong>' + value + '</strong>' + (hideUnit ? '' : UNIT[unit])
}
